import { environment } from '../config/environment';
import { useApiClient } from './api';

export interface GoogleChatNotificationResponse {
  message?: string;
  error?: string;
  details?: any;
}

export const useGoogleChatNotificationService = () => {
  const apiClient = useApiClient();

  const sendRegistrationNotification = async (): Promise<GoogleChatNotificationResponse> => {
    try {
      const response = await apiClient.post<GoogleChatNotificationResponse>(
        `${environment.expressApiUrl}/api/google-chat/registration`
      );
      return response.data;
    } catch (error: any) {
      console.error('Error sending registration notification:', error);
      if (error.response && error.response.data) {
        return error.response.data;
      }
      return {
        error: 'Failed to send registration notification due to a client-side or network error.',
        details: error.message || String(error),
      };
    }
  };

  return { sendRegistrationNotification };
};
